import {
    PortsmouthRecordType,
    PortsmouthRecordSubType
} from "./PortsmouthRecordTypes";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import Feature from "ol/Feature";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import RegularShape from 'ol/style/RegularShape';
import * as olHas from 'ol/has';

export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): (Style | Style[] | StyleFunction)
    {
        let style: (Style | Style[] | StyleFunction) = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {
                case PortsmouthRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
            
                case PortsmouthRecordSubType.RegisteredParksAndGardens:
                    style = this.RegisteredParksAndGardens();
                    break;

                case PortsmouthRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;
            }
        }

        if (style === null) {
            switch (recordType) {
                case PortsmouthRecordType.Monument:
                    style = this.Monument();
                    break;

                case PortsmouthRecordType.Event:
                    style = this.Event();
                    break;

                case PortsmouthRecordType.Designation:
                    style = this.Designation();
                    break;

            }
        }

        return style;
    }
    
    public getSelectedStyle(recordType: PortsmouthRecordType): (Style | Style[] | StyleFunction) {
        let style: (Style | Style[] | StyleFunction) = null;

        switch (recordType) {
            case PortsmouthRecordType.Monument:
                style = this.MonumentSelected();
                break;

            case PortsmouthRecordType.Event:
                style = this.EventSelected();
                break;

            case PortsmouthRecordType.Designation:
                style = this.DesignationSelected();
                break;
        }

        return style;
    }

    private CommonStyle(fillColour: string, outlineColour: string): Style[] {
        let fill = new Fill({
            color: fillColour
        });
        let pointFill = new Fill({
            color: fillColour.replace(/[\d\.]+\)$/g, '1)')
        });
        let stroke = new Stroke({
            color: outlineColour,
            width: 2
        });

        return [
            new Style({
                image: new Circle({
                    fill: pointFill,
                    stroke: new Stroke({ color: 'rgba(0, 0, 0, 1)', width: 1 }),
                    radius: 7
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    
    private Monument(): Style[] {
        return this.CommonStyle('rgba(255, 0, 0, 0.4)', 'rgba(255, 0, 0, 2)');
    }

    private Event(): Style[] {
        return this.CommonStyle('rgba(255, 255, 0, 0.4)', 'rgba(255, 255, 0, 2)');
    }

    private ListedBuilding(): Style[]{
        return this.CommonStyle('rgba(0, 0, 255, 0.4)', 'rgba(0, 0, 255, 2)');
    }
    
    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15, 0.4)', 'rgba(132, 71, 15,2)');
    }

    private ScheduledMonument(): Style[] {       
        let fill = new Fill({
            color: 'rgba(174, 55, 185, 0.4)'
        });
        let stroke = new Stroke({
            color: 'rgba(174, 55, 185, 2)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private RegisteredParksAndGardens(): Style[] {
        let fill = new Fill({
            color: 'rgba(0, 166, 81, 0.4)'
        });

        let stroke = new Stroke({
            color: 'rgba(0, 166, 81, 2)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Selected(): Style[] {
        let fill = new Fill({
            color: 'rgba(63, 211, 0, 0.6)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(76, 255, 0, 0.6)',
                        width: 5
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(76, 255, 0, 2)',
                    width: 5
                })
            })
        ];
    }

    private DesignationSelected(): Style[] {
        //Customise if required
        return this.Selected();
    }

    private EventSelected(): Style[] {
        //Customise if required
        return this.Selected();
    }

    private MonumentSelected(): Style[] {
        //Customise if required
        return this.Selected();
    }

}
